
import {
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    inject,
    ViewEncapsulation
} from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    ControlContainer,
    FormGroupDirective
} from '@angular/forms';
import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { InvoiceCardHeaderAddressComponent } from '../invoice-card-header-address/invoice-card-header-address.component';
import { InvoiceType } from '@shared/zigra-schemas/zigra-schema.autogenerated.models';

@Component({
    selector: 'z-invoice-card-header-contacts',
    imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    ZFloatLabelComponent,
    FieldsetModule
],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InvoiceCardHeaderContactsComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: InvoiceCardHeaderContactsComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './invoice-card-header-contacts.component.html',
    styleUrl: './invoice-card-header-contacts.component.scss'
})
export class InvoiceCardHeaderContactsComponent {
    protected rootFormGroup = inject(FormGroupDirective);
    invoice?: InvoiceType;

    constructor() {
        // this.invoice?.LandPhone
        // this.invoice?.Customer?.ContactDetails?.[0]?.Phone
        //this.invoice?.TypeCode
        // this.invoice?.Customer?.SureName
        // this.invoice?.Customer?.FirstName
        // this.invoice?.Customer?.ContactDetails?.[0]?.EMail
        // this.invoice?.Customer?.ContactDetails?.[0]?.Mobile
    }

    ngOnInit() {
        debugger;
        console.debug(this.rootFormGroup.control.get('Customer'));
        debugger;
    }
}
